import styled from 'styled-components';

export const BasicSearchWrapper = styled('div')<{ addMargin: boolean }>`
  margin-bottom: ${({ addMargin, theme }) =>
    addMargin ? `${theme.x2spacePx}px` : '0'};
  transition: margin-bottom 0.3s ease-in-out;
`;
